<div [ngClass]="{'search-card-disabled': formatGroup.isUnresolved}" class="card py-4 px-4"
     data-automation-id="search-card">
  <div class="row no-gutters card-main-content">

    <!-- Coveri -->
    <div class="cover-wrapper">
      <div class="cover-container pr-3">
        <ng-container *ngIf="!formatGroup.isUnresolved; else staticCover">
          <a
            [routerLink]="['/search', 'card']"
            [queryParams]="{id: formatGroup.id, entityType: entityTypes.FORMAT_GROUP, rapido: true}"
            (keydown)="onSaveFocus($event)"
            (click)="onSaveFocus($event)"
            class="d-inline-block"
            data-automation-id="search-card-image-link"
            [attr.aria-describedby]="ariaTitleId"
            [attr.aria-label]="formatGroup.title">
            <app-cover
              [config]="coverConfig"
              [title]="title"
              [author]="author"
              [materialType]="materialType"
              data-automation-id="search-card-image"
              size="large">
            </app-cover>
          </a>
        </ng-container>
        <ng-template #staticCover>
          <app-cover
            [config]="coverConfig"
            [title]="title"
            [author]="author"
            [materialType]="materialType"
            data-automation-id="search-card-image"
            size="large">
          </app-cover>
        </ng-template>
      </div>
    </div>
    <!-- Contenti -->
    <div class="content-wrapper">
      <div class="row section" #searchCard tabindex="-1" data-automation-id="search-card-focusable">
        <div class="col data-container">
          <ng-container *ngIf="!isListView; else listViewTemplate">
            <h2 class="card-title mb-2" [id]="ariaTitleId">
              <ng-container *ngIf="formatGroup?.isUnresolved; else linkTitle">
                <span class="notranslate">{{ formatGroup.title }}</span>
              </ng-container>
              <ng-template #linkTitle>
                <a
                  [routerLink]="['/search', 'card']"
                  data-automation-id="search-card-title"
                  [queryParams]="{id: formatGroup.id, entityType: entityTypes.FORMAT_GROUP, rapido: true}"
                  (keydown)="onSaveFocus($event)"
                  (click)="onSaveFocus($event)"
                  class="notranslate">
                  {{ formatGroup.title }}
                </a>
              </ng-template>
            </h2>
          </ng-container>
          <ng-template #listViewTemplate>
            <h3 class="card-title mb-2" [id]="ariaTitleId">
              <ng-container *ngIf="formatGroup?.isUnresolved; else linkTitle">
                <span class="notranslate">{{ formatGroup.title }}</span>
              </ng-container>
              <ng-template #linkTitle>
                <a
                  [routerLink]="['/search', 'card']"
                  data-automation-id="search-card-title"
                  [queryParams]="{id: formatGroup.id, entityType: entityTypes.FORMAT_GROUP, rapido: true}"
                  (keydown)="onSaveFocus($event)"
                  (click)="onSaveFocus($event)"
                  class="notranslate">
                  {{ formatGroup.title }}
                </a>
              </ng-template>
            </h3>
          </ng-template>
          <div *ngIf="formatGroup.primaryAgent?.label" class="author mb-2" data-automation-id="author">
            <span class="author-name notranslate">{{ formatGroup.primaryAgent.label }}</span>
          </div>
          <div class="date-range mb-2" data-automation-id="search-card-info">
            <span class="card__publication-info">
              <ng-container *ngIf="formatGroup.publicationDate">
                {{ 'publicationInfo' | translate }}: <span class="notranslate">{{ formatGroup.publicationDate }}</span>
              </ng-container>
              <ng-container *ngIf="formatGroup.publicationDate && formatGroup.language"> | </ng-container>
              <ng-container *ngIf="formatGroup.language"><span class="notranslate">{{ language }}</span></ng-container>
            </span>
          </div>
          <div *ngIf="formatGroup?.seriesTitle" class="series-info mb-2">
            <ng-container *ngIf="isRapido; else linkedSeriesTitle">
              <fa-icon [icon]="booksIcon" class="mr-1"></fa-icon>
              <span data-automation-id="series-title" class="notranslate">{{ formatGroup.seriesTitle }}</span>
            </ng-container>
            <ng-template #linkedSeriesTitle>
              <a href=""
                 data-automation-id="series-title"
                 (keydown.enter)="$event.preventDefault(); onSeriesTypeSearch($event, formatGroup.seriesTitle, formatGroup.seriesTitleSearch)"
                 (click)="$event.preventDefault(); onSeriesTypeSearch($event, formatGroup.seriesTitle, formatGroup.seriesTitleSearch)"
                 class="link notranslate">
                <fa-icon [icon]="booksIcon" class="mr-1"></fa-icon>
                <span class="notranslate">{{ formatGroup.seriesTitle }}</span>
              </a>
            </ng-template>
          </div>
          <div class="not-found-words mt-2" *ngIf="notFoundWords.length" data-automation-id="not-found-words">
            {{ 'missingWords' | translate }} <span class="mr-1" *ngFor="let word of notFoundWords">{{ word }}</span>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col not-found-words">
          <ng-container *ngTemplateOutlet="suppressedItemLabelVIew"></ng-container>
        </div>
      </div>
      <div class="row">
        <ng-container *ngTemplateOutlet="tabsView"></ng-container>
      </div>
    </div>
  </div>

</div>

<!-- Suppressed item label template -->
<ng-template #suppressedItemLabelVIew>
  <span class="search-card-label mb-2" *ngIf="formatGroup?.isUnresolved">
    {{ 'suppressedItemLabel' | translate: {recordId: formatGroup?.materialTabs[0]?.recordIds[0]} }}
  </span>
</ng-template>

<!-- Tabs View -->
<ng-template #tabsView>
  <div class="col">
      <app-rollup-tabs-rapido
          [materialTabs]="formatGroup.materialTabs"
          [availabilityUpdates]="availabilityUpdates"
          [queryParams]="queryParams"
          [fgId]="formatGroup.id"
          [fgTitle]="formatGroup.title"
          [author]="formatGroup.primaryAgent?.label"
          [publicationYear]="formatGroup.publicationDate"
          [publisher]="formatGroup.publisher"
          [specificEdition]="formatGroup.specificEdition"
          [isbn]="formatGroup.identifiers?.isbn"
          data-automation-id="rollup-tabs"
          (getIt$)="getIt$.emit($event)"
          (placeHold$)="placeHold$.emit($event)"
          [ariaDescribedBy]="ariaTitleId"
          [language]="language"
          [edition]="edition"
          >
        </app-rollup-tabs-rapido>
  </div>
</ng-template>
